import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { LoginService } from 'src/app/services/login.service';
import { UsersService } from 'src/app/services/users.service';
import {
  AdministrativeAccountsUsersReportV2Service,
  AccountsUsersReportRow,
} from 'src/app/services/administrative-accounts-users-report-v2.service';
import { AccountsUsersReportFilter } from 'src/app/services/administrative-accounts-users-report-v2.service';
import { IDatatableOutputDTO } from 'src/app/shared/datatables/datatables';
import { DefaultResponse } from 'src/app/pages/base.interface';
import { finalize } from 'rxjs/operators';
import { MSG } from 'src/app/util/constants';

@Component({
  selector: 'app-administrative-accounts-users-report',
  templateUrl: './accounts-users-report.component.html',
  styleUrls: ['./accounts-users-report.component.scss'],
})
export class AdministrativeAccountsUsersReportComponent implements OnInit {
  loading = false;

  dataSource: MatTableDataSource<AccountsUsersReportRow> =
    new MatTableDataSource([]);
  displayedColumns: string[] = [
    'accountName',
    'accountMobile',
    'accountEmail',
    'userName',
    'userEmail',
    'status',
    'actions',
  ];

  total = 0;
  pageIndex = 0;
  pageSize = 10;

  filters: FormGroup<{
    search: FormControl<string>;
  }>;
  resendingUserId: number | null = null;

  constructor(
    private readonly service: AdministrativeAccountsUsersReportV2Service,
    private readonly usersService: UsersService,
    private readonly formBuilder: FormBuilder,
    private readonly loginService: LoginService
  ) {
    this.filters = this.formBuilder.nonNullable.group({
      search: '',
    });
  }

  ngOnInit(): void {
    this.onSearch();
  }

  onSearch(event?: PageEvent): void {
    this.loading = true;

    if (event) {
      this.pageIndex = event.pageIndex;
      this.pageSize = event.pageSize;
    } else {
      this.pageIndex = 0;
    }

    const rawSearch: string = this.filters.value.search.trim();
    const filter: AccountsUsersReportFilter = {};

    if (rawSearch) {
      filter.userEmail = rawSearch;
    }

    this.service
      .search({
        filter,
        page: this.pageIndex + 1,
        perPage: this.pageSize,
      })
      .pipe(finalize(() => (this.loading = false)))
      .subscribe(
        (datatable: IDatatableOutputDTO<AccountsUsersReportRow>) => {
          this.dataSource.data = [...(datatable.rows ?? [])];
          this.total = datatable.total ?? 0;
        },
        () => {
          this.loginService.showMessage('Erro ao carregar usuários.', 3000);
        }
      );
  }

  applySearch(): void {
    this.onSearch();
  }

  resendActivation(userId: number | null | undefined): void {
    if (userId == null) return;
    this.resendingUserId = userId;
    this.usersService
      .onSendInvitation(userId)
      .pipe(finalize(() => (this.resendingUserId = null)))
      .subscribe(
        (response: DefaultResponse<void>) => {
          if (response?.status) {
            this.loginService.showMessage(
              MSG.REGISTER_EMAIL_SENT_SUCCESSFULLY,
              3000
            );
          } else {
            this.loginService.showMessage(
              MSG.REGISTER_EMAIL_SENT_ERROR,
              3000
            );
          }
        },
        () => {
          this.loginService.showMessage(
            MSG.REGISTER_EMAIL_SENT_ERROR,
            3000
          );
        }
      );
  }

  formatPhone(phone: string | null | undefined): string {
    if (!phone) return '-';
    const digits = phone.replace(/\D/g, '');
    if (digits.length === 11)
      return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
    if (digits.length === 10)
      return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
    return phone;
  }
}
